export default __webpack_public_path__ + "static/media/influencer.9a885091.png";